import { getFirstName } from 'utils';
import { getCurrentUser, isUserLoading, isRegisteredUser } from 'redux/query';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'Common';
import { logoutUser } from 'redux/actions';

export const ProfileNavigationHeader = () => {
  const dispatch = useDispatch();

  const user = useSelector(getCurrentUser);
  const isLoading = useSelector(isUserLoading);
  const registeredUser = useSelector(isRegisteredUser);

  if (!registeredUser) {
    return dispatch(logoutUser());
  }

  if (isLoading || !user) {
    return <Spinner />;
  }

  return (
    <div className="profile-navigation-header">
      <div className="profile-navigation-header__user-name" data-cy-name="greeting-header">
        Hallo {getFirstName(user?.firstName)}!
      </div>
    </div>
  );
};
